import { render, staticRenderFns } from "./safetysupervisioninspectionList.vue?vue&type=template&id=10b9e55c&scoped=true"
import script from "./safetysupervisioninspectionList.vue?vue&type=script&lang=js"
export * from "./safetysupervisioninspectionList.vue?vue&type=script&lang=js"
import style0 from "./safetysupervisioninspectionList.vue?vue&type=style&index=0&id=10b9e55c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9e55c",
  null
  
)

export default component.exports